import React, { useEffect, useLayoutEffect } from 'react';
import CasinoContainer from '../../../../../components/casino/CasinoContainer';
import BannerContent from './BannerContent';
import { useNavigate, useParams } from 'react-router';
import { useAppSelector } from '../../../../../store';
import ShowContainer from '../../../../../components/material-ui/ShowContainer';
import { Box, Stack } from '@mui/material';

export default function SettingsBanner() {
  const { langCode, casinoId } = useParams();

  const navigate = useNavigate();
  const languages = useAppSelector((state) => state.info.casinoLanguages);
  const langs = languages.map((el) => el.lang);

  useLayoutEffect(() => {
    if (!langs.length) return;
    if (langs.includes(langCode)) return;
    navigate(`/casino/design/banners/${casinoId}/${langs[0]}`);
  }, [langCode, langs]);

  return (
    <CasinoContainer title={'Banner images'}>
      <ShowContainer condition={langs.includes(langCode)}>
        <BannerContent />
      </ShowContainer>
    </CasinoContainer>
  );
}
